/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.conditions.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from './app.config.service';
import {Condition} from '../modules/admin/model/condition';
import {AppUserService} from './app.user.service';
import {map} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import {AppEventService} from './app.event.service';

/**
 * Zweck: Beschreibt class AppConditionsService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppConditionsService {
  open_conditions = new BehaviorSubject<Condition[]>(undefined);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient, private cfg: AppConfigService, private usvc: AppUserService, private esvc: AppEventService) {
    this.usvc.user$.subscribe(u => {
      this.load();
    });

    this.esvc.getQueue().subscribe(e => {
      if (e.name == 'App\\Events\\ConditionEngine\\ConditionChangedEvent') {
        this.load();
      }
    });
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    this.getForCustomer().subscribe(cs => {
      this.open_conditions.next(cs);
    });
  }

/**
 * Beschreibt Methode getForCustomer und ihren Rückgabevertrag.
 */
  getForCustomer() {
    return this.http.get<Condition[]>(
      '/condition/getall'
    );
  }

/**
 * Beschreibt Methode acceptConditions und ihren Rückgabevertrag.
 */
  acceptConditions(c: Condition) {
    const me = this;
    return this.http.get<boolean>(
      '/condition/' + c.matchcode + '/accept'
    ).pipe(map((result: boolean) => {
      this.load();
      return result;
    }));
  }

/**
 * Beschreibt Methode declineConditions und ihren Rückgabevertrag.
 */
  declineConditions(c: Condition) {
    return this.http.get<boolean>(
      '/condition/' + c.matchcode + '/decline'
    ).pipe(map((result: boolean) => {
      this.load();
      return result;
    }));
  }

/**
 * Beschreibt Methode orderupConditions und ihren Rückgabevertrag.
 */
  orderupConditions(c: Condition) {
    const me = this;
    return this.http.get<boolean>(
      '/admin/condition/orderup/' + c.id
    ).pipe(map((result: boolean) => {
      this.load();
      return result;
    }));
  }

/**
 * Beschreibt Methode orderdownConditions und ihren Rückgabevertrag.
 */
  orderdownConditions(c: Condition) {
    const me = this;
    return this.http.get<boolean>(
      '/admin/condition/orderdown/' + c.id
    ).pipe(map((result: boolean) => {
      this.load();
      return result;
    }));
  }

/**
 * Beschreibt Methode getAllConditions und ihren Rückgabevertrag.
 */
  getAllConditions() {
    return this.http.get<Condition[]>(
      '/admin/condition/getall'
    );
  }

/**
 * Beschreibt Methode getConditionById und ihren Rückgabevertrag.
 */
  getConditionById(id: string) {
    return this.http.get<Condition>(
      '/admin/condition/get/' + id
    );
  }

/**
 * Beschreibt Methode saveCondition und ihren Rückgabevertrag.
 */
  saveCondition(condition: Condition) {
    return this.http.post<Boolean>(
      '/admin/condition/update/' + condition.id,
      {
        post_condition: condition
      }
    );
  }
}
